export default __webpack_public_path__ + "static/media/mb5.97b7efa2.jpg";